import {
  isShowRegularPayBtn,
  isShowEarlyPayBtn,
  isShowNotifyMenu,
  isShowAwaitingIcon,
  getAwaitingTooltip,
} from '../helpers/earlyRepayment';

export default {
  data() {
    return {
      isEarlyRepaymentMenuOpen: false,
    };
  },
  methods: {
    hideEarlyRepaymentMenu() {
      this.isEarlyRepaymentMenuOpen = false;
    },
    toggleEarlyRepaymentMenu() {
      this.isEarlyRepaymentMenuOpen = !this.isEarlyRepaymentMenuOpen;
    },
    openEarlyRepaymentNotify() {
      this.hideEarlyRepaymentMenu();
      this.$emit('openEarlyRepaymentNotify', { loan_public_id: this.item.public_id });
    },
    openEarlyRepaymentPay() {
      this.hideEarlyRepaymentMenu();
      this.$emit('openEarlyRepaymentPay', { loan_public_id: this.item.public_id });
    },
  },
  computed: {
    isShowEarlyRepaymentMenu() {
      return this.isShowNotifyMenu || this.isShowEarlyPayBtn;
    },
    isShowRegularPayBtn() {
      return isShowRegularPayBtn(this.item);
    },
    isShowEarlyPayBtn() {
      return isShowEarlyPayBtn(this.item);
    },
    isShowNotifyMenu() {
      return isShowNotifyMenu(this.item);
    },
    isShowAwaitingIcon() {
      return isShowAwaitingIcon(this.item);
    },
    awaitingTooltip() {
      return getAwaitingTooltip(this.item, (key, params) => this.$t(key, params));
    },
    hasEarlyRepaymentActions() {
      return this.isShowNotifyMenu || this.isShowAwaitingIcon;
    },
    lastPaymentTransaction() {
      if (this.item?.repaymentPayment) {
        return this.item.repaymentPayment;
      }

      const itemValues = Object.values(this.item || {});
      return itemValues.find(value => {
        return value
          && typeof value === 'object'
          && 'payment_public_id' in value
          && 'in_progress' in value;
      }) || null;
    },
    isLastPaymentInProgress() {
      return this.lastPaymentTransaction?.in_progress === true;
    },
    isLastPaymentFailed() {
      return this.lastPaymentTransaction?.in_progress === false
        && this.lastPaymentTransaction?.status === 'FAILED';
    },
  },
};
